// extracted by mini-css-extract-plugin
export default {"container":"Header--container--Uvd7X","isScrolling":"Header--isScrolling--E+mFF","menu":"Header--menu--dTyc-","items":"Header--items--n177P"};